export default "__VITE_ASSET__3cb65d42__"